/**
 *
 * Cell
 *
 */

import React from 'react';
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';
import type { BreakpointType } from '@fil-react-types/types';

import styles from './Cell.style';

export interface CellProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
  auto?: boolean;
  shrink?: boolean;
  center?: boolean;
  sm?: number | string;
  md?: number | string;
  lg?: number | string;
  xlg?: number | string;
  xxlg?: number | string;
  // @ts-ignore
  offset?: BreakpointType;
  // @ts-ignore
  offsetRight?: BreakpointType;
}

const Cell: React.FC<CellProps> = ({
  className,
  children,
  sm,
  md,
  lg,
  offset,
  auto,
  shrink,
  center,
  offsetRight,
  ...otherProps
}) => (
  <div className={classnames('cell', className)} {...otherProps}>
    {children}
  </div>
);

Cell.displayName = 'Cell';

export default withStyles(Cell, styles);
